module.exports = __webpack_public_path__ + "img/116.0d644c03.jpg";